__turbopack_context__.v({
  "header": "root-page-share-module-scss-module__of5Niq__header",
  "section": "root-page-share-module-scss-module__of5Niq__section",
  "title": "root-page-share-module-scss-module__of5Niq__title",
});
